import api from './api';
import { InstanceData } from '@/types';

export interface MetaTemplateComponent {
  type: string;
  format?: string;
  text?: string;
  buttons?: Array<{
    type: string;
    text?: string;
    url?: string;
    phone_number?: string;
  }>;
  example?: {
    header_text?: string[][];
    body_text?: string[][];
    header_handle?: string[];
  };
}

export interface MetaTemplate {
  id: string;
  name: string;
  status: string;
  language: string;
  category: string;
  components?: MetaTemplateComponent[];
}

export interface CreateTemplateData {
  instanciaId: string;
  name: string;
  language: string;
  category: string;
  components: MetaTemplateComponent[];
}

export interface MetaBusinessProfile {
  about?: string;
  address?: string;
  description?: string;
  email?: string;
  profile_picture_url?: string;
  vertical?: string;
  websites?: string[];
}

export const instanciaService = {
  listar: () => api.get('/instancias'),
  obter: (id: string) => api.get(`/instancias/${id}`),
  criar: (data: InstanceData) => api.post('/instancias', data),
  atualizar: (id: string, data: Partial<InstanceData>) => api.put(`/instancias/${id}`, data),
  conectar: (id: string) => api.post(`/instancias/${id}/conectar`),
  desconectar: (id: string) => api.post(`/instancias/${id}/desconectar`),
  obterQRCode: (id: string) => api.get(`/instancias/${id}/qrcode`),
  verificarStatus: (id: string) => api.get(`/instancias/${id}/status`),
  recriar: (id: string) => api.post(`/instancias/${id}/recreate`),
  definirPadrao: (id: string) => api.patch(`/instancias/${id}/padrao`),
  // Instância confidencial (só SuperAdmin)
  definirConfidencial: (id: string, confidencial: boolean) => api.patch(`/instancias/${id}/confidencial`, { confidencial }),
  // Integração N8N da instância confidencial (só SuperAdmin; desligada por padrão)
  definirN8nConfidencial: (id: string, n8nConfidencial: boolean) => api.patch(`/instancias/${id}/confidencial`, { n8nConfidencial }),
  fetchMetaDados: (code: string, redirectUri?: string, appId?: string) => api.post(`/instancias/meta/fetch-data`, { code, redirectUri, appId }),
  descobrirMetaWaba: (accessToken: string, appId?: string): Promise<{ data: { wabaId: string; phoneNumbers: Array<{ id: string; display_phone_number?: string; verified_name?: string }>; wabas: Array<{ id: string; name?: string | null; phoneNumbers: Array<{ id: string; display_phone_number?: string; verified_name?: string }> }> } }> =>
    api.post(`/instancias/meta/discover`, { accessToken, appId }),
  obterConfigProviderMeta: (): Promise<{ data: { appId: string | null; configId: string | null } }> =>
    api.get(`/instancias/meta/provider-config`),
  obterConfigMeta: (): Promise<{ data: { config: { id?: string | null; empresaId?: string | null; appId: string | null; configId: string | null; appSecretConfigured: boolean; webhookVerifyTokenConfigured: boolean } } }> =>
    api.get(`/instancias/meta/config`),
  salvarConfigMeta: (data: { appId: string; configId: string; appSecret?: string; webhookVerifyToken?: string }) =>
    api.put('/instancias/meta/config', data),
  listarTemplates: (id: string, params?: { status?: string; name?: string }) =>
    api.get(`/instancias/${id}/templates`, { params }),
  obterTemplate: (instanciaId: string, templateId: string) =>
    api.get(`/instancias/meta/template/${templateId}`, { params: { instanciaId } }),
  criarTemplate: (data: CreateTemplateData) =>
    api.post('/instancias/meta/template', data),
  atualizarTemplate: (templateId: string, data: CreateTemplateData) =>
    api.post(`/instancias/meta/template/${templateId}`, data),
  excluirTemplate: (instanciaId: string, templates: { name: string; language: string }[]) =>
    api.delete('/instancias/meta/template', { data: { instanciaId, templates } }),
  obterInstanciaVinculada: (metaInstanceId: string) =>
    api.get(`/instancias/${metaInstanceId}/linked`),
  obterPerfilComercial: (id: string) =>
    api.get(`/instancias/${id}/meta/business-profile`),
  atualizarPerfilComercial: (id: string, data: MetaBusinessProfile) =>
    api.put(`/instancias/${id}/meta/business-profile`, data),
  obterWebhookMeta: (id: string) =>
    api.get<MetaWebhookStatus>(`/instancias/${id}/meta/webhook-status`),
  reinscreverWebhookMeta: (id: string) =>
    api.post<MetaWebhookStatus>(`/instancias/${id}/meta/webhook/resubscribe`),
};

// Para onde a Meta entrega os webhooks da WABA, comparado com o callback deste ambiente.
export interface MetaWebhookStatus {
  situacao: 'ok' | 'outro_destino' | 'padrao' | 'nao_inscrito';
  ambiente: string;
  wabaId: string;
  appId: string | null;
  esperado: string | null;
  atual: string | null;
  apps: { appId: string | null; appName: string | null; overrideCallbackUri: string | null }[];
}
